window.o_global = window.o_global || {};

/**
 * Wrapper class for securely accessing webstorage.
 * Provides W3C compliant API to access localStorage or sessionStorage.
 * Additionally adds meaningful return values, e.g. for setItem and
 * removeItem to check if operation was successful.
 *
 * @class
 *
 * @param {Object} storage      Could be either localStorage or sessionStorage object depending on what one wants to use.
 */
o_global.Storage = function(storage) {
    "use strict";

    if (o_util.cookie.exists("app") && navigator.userAgent.indexOf("OS 11_3 like Mac OS X") !== -1) {
        this.isAvailable = false;

        return;
    }

    var paramType = typeof storage;

    // Try to evaluate given function expression to prevent raised exceptions in modules using storage wrapper.
    // Use regular param otherwise.
    if (paramType === "function") {
        try {
            this.storage = storage();
        } catch (e) {
            // TODO: LHAS-831 - Add global error logging.
        }
    } else {
        this.storage = storage;
    }

    this.isAvailable = this.isStorageAvailable();
};

/**
 * Determine reliably if the storage does not only exists, but is also usable.
 * Background: Safari on iOS/OSX [storage].setItem throws Quota-Exception in private mode.
 *
 * @return {Boolean} Determines if the chosen webstorage is available.
 */
o_global.Storage.prototype.isStorageAvailable = function() {
    "use strict";

    var enabled = false,
        storageTest;

    try {
        this.storage.setItem("storageTest", "test");
        storageTest = this.storage.getItem("storageTest");
        this.storage.removeItem("storageTest");
        enabled = true;
    } catch (e) {
    }

    return enabled;
};

/**
 * Saves an item to localStorage.
 *
 * @param {String} key      Storage key.
 * @param {String} value    Value to be stored.
 *
 * @return {Boolean}        true, if the item was saved successfully.
 */
o_global.Storage.prototype.setItem = function(key, value) {
    "use strict";

    var success = false;

    if (this.isAvailable && arguments.length === 2) {
        try {
            this.storage.setItem(key, value);
        } catch (e) {
            // Log exception to splunk for further analysis.
            if (!!window.AS && !!window.AS.RUM && !!window.AS.RUM.sendCustomRequest && typeof window.AS.RUM.sendCustomRequest === "function") {
                window.AS.RUM.sendCustomRequest("localStorageError", {
                    "message": e.toString() + " | " + location.href + " | " + navigator.userAgent
                });
            }

            return false;
        }

        success = !!this.storage.getItem(key);
    }

    return success;
};

/**
 * Return the value of an item in storage, null if no item was found.
 *
 * @param {String} key      Item key that should be retrieved.
 *
 * @return {String|Null}    The value of the item.
 */
o_global.Storage.prototype.getItem = function(key) {
    "use strict";

    if (this.isAvailable) {
        return this.storage.getItem(key);
    }
};

/**
 * Delete an item from storage.
 *
 * @param {String} key      This storage item should be removed.
 *
 * @return {Boolean} Always return "true" if the given item doesn't exist in storage.
 */
o_global.Storage.prototype.removeItem = function(key) {
    "use strict";

    var success = false;

    if (this.isAvailable && !!key) {
        this.storage.removeItem(key);
        success = !this.storage.getItem(key);
    }

    return success;
};

/**
 * Caution: will delete ALL items in storage!
 *
 * @return {Boolean}    true, if the clear was successfully and all items were deleted.
 */
o_global.Storage.prototype.clear = function() {
    "use strict";

    var i = 0,
        success = false;

    if (this.isAvailable) {
        // Iterate over the storage and remove all items.
        for (var key in this.storage) {
            if (this.storage.hasOwnProperty(key)) {
                this.removeItem(key);
            }
        }

        // Test if all storage item were really removed.
        for (key in this.storage) {
            if (this.storage.hasOwnProperty(key)) {
                i++;
            }
        }

        if (i === 0) {
            success = true;
        }
    }

    return success;
};
